module.exports = require("./BladeContainer");


//////////////////
// WEBPACK FOOTER
// external "./BladeContainer"
// module id = 8
// module chunks = 3